import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { extractErrorMessage } from '../utils/apitools'
import useAccount from './useAccount'
import { API_BASE_URL } from '../constants/system'

export interface CustomerTracker {
  slug: string
  title: string
  subtitle: string
  customer: string
}

interface ListTrackersResponse {
  trackers: CustomerTracker[]
}

// useCustomerTrackers lists the programme trackers configured for a customer,
// so the nav can show a link only when the selected customer has one (and
// automatically picks up trackers for any customer added in future).
export const useCustomerTrackers = (customer: string) => {
  const account = useAccount()

  const query = useQuery({
    queryKey: ['programme-trackers', { customer }],
    enabled: Boolean(customer && account.user),
    queryFn: async () => {
      if (!customer || !account.user) return []
      try {
        const res = await axios.get<ListTrackersResponse>(
          `${API_BASE_URL}/projects?customer=${encodeURIComponent(customer)}`
        )
        return res.data.trackers || []
      } catch (error) {
        throw new Error(extractErrorMessage(error))
      }
    },
  })

  return { trackers: query.data || [] }
}

export default useCustomerTrackers
